import { tokens } from '@cast/design-system';

import type { ScalingPolicyCategory } from '../_hooks/useScalingPoliciesCardData';

/** Theme-aware data tokens so segments invert correctly in dark mode. */
export const SCALING_POLICY_CATEGORY_COLORS: Record<
  ScalingPolicyCategory['key'],
  string
> = {
  system: tokens.theme.data.grey900,
  ops: tokens.theme.data.indigo300,
  custom: tokens.theme.data.yellow300,
};

export const SCALING_POLICY_CATEGORY_COLOR_LIST = [
  SCALING_POLICY_CATEGORY_COLORS.system,
  SCALING_POLICY_CATEGORY_COLORS.ops,
  SCALING_POLICY_CATEGORY_COLORS.custom,
] as const;
